/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Typography from '@mui/material/Typography'
import { Fragment } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { useI18n } from '@popety_io/popety-io-lib'

import GridHeader from '../Configuration/GridHeader'
import GridData from '../Configuration/GridData'
import CollapseList from './LandSummaryContent/CollapseList'

const GeneralInformation = ({
  data,
  editedLand,
}: {
  data: Record<string, any>
  editedLand?: Record<string, any>
}) => {
  const { t } = useI18n()

  const data1 = [
    {
      label: t('common.EGRID'),
      value: editedLand?.egrid ? editedLand?.egrid : data?.egrid_nb,
      name: 'egrid',
    },
    {
      label: t('land.zone.number'),
      value: editedLand?.landNumber
        ? editedLand?.landNumber
        : data?.code_number,
      name: 'landNumber',
    },
    {
      label: t(`common.type`),
      value: editedLand?.landType ? editedLand?.landType : data?.type,
      name: 'landType',
    },
  ]

  const data2 = [
    {
      label: '',
      value: (
        <CollapseList
          items={data?.addresses}
          moreKey="common.seeMoreAddresses"
        />
      ),
      name: '',
    },
  ]

  return (
    <Box>
      <GridHeader title="Informations générales" />
      <Box
        sx={{
          backgroundColor: '#F9F9F9',
          padding: '6px',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <GridData data={data1} title="Identification" />
          </Grid>
          <Grid item xs={6}>
            {data2?.map((item: any) => (
              <Fragment key={item.label as string}>
                <Typography
                  fontSize="1rem"
                  fontWeight="500"
                  sx={{
                    marginBottom: '4px',
                  }}
                >
                  {t('common.addresses')}
                </Typography>
                <Grid item xs={12} sm={8}>
                  {item.value}
                </Grid>
              </Fragment>
            ))}{' '}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default GeneralInformation
